const { name, version, dependencies } = require('../../package.json');

const sentry = ({ cityInfo, sentryDsn, sentrySampleRate }) => `
    <script>
        function loadScripts(scripts, callback) {
            var promises = scripts.map(function(src) {
                return new Promise(function (resolve, reject) {
                    const script = document.createElement('script');
                    script.src = src;
                    script.async = true
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                });
            });
        
            return Promise.all(promises).then(callback);
        };

        loadScripts(
            [
                'https://browser.sentry-cdn.com/10.45.0/bundle.tracing.min.js', 
                'https://browser.sentry-cdn.com/10.45.0/captureconsole.min.js'
            ],
            function() {
                Sentry.init({
                    dsn: '${sentryDsn}',
                    release: '${version}',
                    environment: '${process.env.ENVIRONMENT}',
                    sampleRate: ${sentrySampleRate},
                    normalizeDepth: ${parseInt(process.env.SENTRY_NORMALIZE_DEPTH || '4', 10)},
                    sendDefaultPii: true,
                    ignoreErrors: [
                        'googletagmanager',
                        /jquery'/i,
                        /avast/i,
                        'arr_prods',
                        'attempts',
                        'cadesplugin'
                    ],
                    ignoreUrls: [
                        /extensions\\//i,
                        /^chrome:\\/\\//i,
                        /chrome-extension:\\/\\//i,
                        /moz-extension:\\/\\//i
                    ],
                    beforeSend: function(event) {
                        event.tags = event.tags || {};
                        event.tags.logger = event.tags.logger || '_default_';
                        return event;
                    },
                    tracesSampleRate: 0.05,
                    integrations: [
                        Sentry.browserTracingIntegration(),
                        Sentry.captureConsoleIntegration({ levels: ['error'] })
                    ]
                });

                const scope = Sentry.getCurrentScope();
                scope.setTags({
                    isModernBrowser: window.__IS_MODERN_BROWSER__,
                    cityID: ${cityInfo.id},
                    cityTitle: "${cityInfo.cityTitle}",
                    fiasId: "${cityInfo.fiasId}",
                    instance: "${name}"
                });
            });
    </script>
`;

module.exports = {
    sentry
};
